<template>
  <section
    class="pt-7 px-9 roboto homecontainer mx-auto bg-skin-primary text-skin-secondary"
  >
    <div
          @click="$router.go(-1)"
          class="blue-font cursor-pointer my-3 d-flex align-items-center text-skin-description"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style="max-width:17px"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M7 16l-4-4m0 0l4-4m-4 4h18"
            />
          </svg>
          <span class="ml-2">volver</span>
        </div>
    <div class="flex cart-box">
      <div class="w-3/4 pl-5 box-100  bg-skin-primary">
        <p class="title-cart mb-10 text-skin-secondary">Carrito de compras</p>
        <div class="cart pl-14 mt-14">
          {{ carShop.length }} cursos en la cesta
        </div>
        <div class="product-box mt-3 bg-skin-primary">
          <div v-for="data in cartItems" :key="data.id">
            <ProductCart @refresh="getShoppingCart" :data="data"></ProductCart>
          </div>
        </div>
      </div>
      <div class="w-1/4 go-buy box-100" align="center">
        <span class="price-course">
          $ {{ total_price }} <span class="usd">USD</span>
        </span>
        <br />
        <div
          class="add-course-button mt-6 cursor-pointer"
          @click="showPayments"
        >
          Adquirir Curso
        </div>
        <section
          v-if="showMethodPay"
          class="border border-skin-secondary px-2 py-3 rounded-md mt-4 flex justify-around items-end"
        >
          <button @click="paymentezPay" class="focus:outline-none">
            <PaymentezIcon />
          </button>
        </section>
        <div
          class="add-cart-button mt-6 cursor-pointer"
          align="center"
          @click="goToCategories"
        >
          Seguir Comprando
        </div>
      </div>
    </div>
    <CourseInteresed class="mt-10" />
    <LoadingPayment v-if="loadingPayment" />
  </section>
</template>

<script>
import ProductCart from "../../src/components/ProductCart.vue";
import LoadingPayment from "../../src/components/LoadingPayment.vue";
import PaymentezIcon from "../components/icons/Paymentez.vue";
import CourseInteresed from "../components/CourseInteresed.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    ProductCart,
    LoadingPayment,
    CourseInteresed,
    PaymentezIcon,
  },
  data() {
    return {
      showMethodPay: false,
      loadingPayment: false,
      cartItems: [],
    };
  },
  computed: {
    ...mapGetters({
      carShop: "shopingCart/getCart",
      total_price: "shopingCart/price_total",
      userLogged: "getUser/GET_USER",
    }),
  },
  mounted() {
    this.getShoppingCart();
  },
  methods: {
    showPayments() {
      if (this.carShop.length > 0) this.showMethodPay = !this.showMethodPay;
    },
    getShoppingCart() {
      this.$store
        .dispatch("shopingCart/getCart")
        .then((data) => (this.cartItems = data));
    },
    goToCategories() {
      this.$router.push({ name: "v2-categories", query: { q: "" } });
    },
    paymentezPay() {
      const _total = this.total_price;
      const self = this;
      const client = process.env.VUE_APP_PAYMENTEZ_CLIENT;
      const secret = process.env.VUE_APP_PAYMENTEZ_SECRET;
      const env = process.env.VUE_APP_ENVIROMENT;
      const order_vat = parseFloat((_total / 1.12) * 0.12).toFixed(2);
      const taxable_amount = parseFloat(_total / 1.12).toFixed(2);

      var paymentezCheckout = new PaymentezCheckout.modal({
        client_app_code: client,
        client_app_key: secret,
        locale: "es",
        env_mode: env,
        onResponse(response) {
          self.loadingPayment = true;
          const transaction = response.transaction.status;
          self.storePayment(response, transaction);
        },
      });

      paymentezCheckout.open({
        user_id: self.userLogged.user_id.toString(),
        user_email: self.userLogged.email,
        order_description: "Compra cursos salude",
        order_amount: _total,
        order_vat: Number(order_vat),
        order_taxable_amount: Number(taxable_amount),
        order_reference: "#234323411",
        order_tax_percentage: 12,
      });
    },
    async storePayment(response, type) {
      const _url = `/api/v2/${type === "success" ? "approved" : "refused"}`;

      try {
        await axios.post(
          _url,
          {
            user_id: this.userLogged.user_id,
            transactional_id: response.card.transaction_reference,
            payment_method_id: 1,
            authorization_code: response.transaction.authorization_code,
            status: type,
            amount: response.transaction.amount,
            data: response,
          },
          {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("a_t")}`,
            },
          }
        );
        this.getShoppingCart();
        localStorage.setItem("paymentIsSuccess", type);
      } catch (error) {
        localStorage.setItem("paymentIsSuccess", "refused");
      }

      this.$router.push({
        name: "payment-info",
      });
    },
  },
};
</script>

<style scoped>
.go-buy {
  margin-top: 120px;
  padding: 25px;
  text-align: left;
}

.add-cart-button {
  font: normal normal medium 16px/18px Roboto;
  letter-spacing: 0px;
  color: #f28062;
  opacity: 1;
}

.title-cart {
  font: normal normal medium 30px/18px Roboto;
  letter-spacing: 0px;
  font-size: 30px;
  font-weight: 600;
}

.price-course {
  font: normal normal 900 40px/48px Roboto;
  letter-spacing: 0px;
  color: #e76474;
  opacity: 1;
}

.add-course-button {
  background: transparent linear-gradient(270deg, #de357a 0%, #f08f6e 100%) 0%
    0% no-repeat padding-box;
  border-radius: 19px;
  opacity: 1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 37px;
}

@media (max-width: 1024px) {
  .cart-box {
    flex-direction: column;
  }

  .product-box {
    padding: 10px;
  }

  .go-buy {
    text-align: center;
  }

  .box-100 {
    width: 100%;
    padding-left: 0 !important;
  }

  .cart {
    padding-left: 0px !important;
  }
}
</style>
